module.exports = __webpack_public_path__ + "static/media/broker-zoom-out.9f39453d.svg";